import * as Yup from 'yup';

export const createEmailValidation = (errorMessage?: string) => {
  const defaultMessage =
    'El email debe tener un formato válido con dominio (ej: usuario@dominio.com)';

  return Yup.string()
    .required('Este campo es requerido')
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, errorMessage || defaultMessage)
    .test('valid-email-domain', errorMessage || defaultMessage, (value) => {
      if (!value) return false;

      const parts = value.split('@');
      if (parts.length !== 2) return false;

      const [localPart, domain] = parts;

      if (!localPart || localPart.length === 0) return false;

      if (!domain || !domain.includes('.')) return false;

      const domainParts = domain.split('.');
      if (domainParts.length < 2) return false;

      for (const part of domainParts) {
        if (!part || part.length === 0) return false;
      }

      const tld = domainParts[domainParts.length - 1];
      if (tld.length < 2) return false;

      return true;
    });
};

export const emailValidation = createEmailValidation();
